import { match } from 'ts-pattern'
import {
  ColumnsContentSection,
  ColumnsContentSectionProps,
} from './sections/ColumnsContentSection'
import {
  DataContentSection,
  DataSectionItem,
  DataSectionItemStyling,
  DataSectionType,
} from './sections/DataContentSection'
import {
  DocumentSectionItem,
  DocumentSectionType,
  DocumentsContentSection,
} from './sections/DocumentsContentSection'
import {
  LocationContentSection,
  LocationSectionType,
} from './sections/LocationContentSection'
import {
  StepSectionItem,
  StepSectionType,
  StepsContentSection,
} from './sections/StepsContentSection'
import {
  TextContentSection,
  TextSectionType,
} from './sections/TextContentSection'
import {
  CtaContentSection,
  CtaContentSectionType,
} from './sections/CtaContentSection'
import {
  NewsContentSection,
  NewsContentSectionType,
} from './sections/NewsContentSection'
import {
  StoriesContentSection,
  StoriesContentSectionType,
} from './sections/StoriesContentSection'
import {
  ThreadContentSection,
  ThreadContentSectionType,
} from './sections/ThreadContentSection'
import {
  InitiativesContentSection,
  InitiativesContentSectionType,
} from './sections/InitiativesContentSection'
import {
  FaqContentSection,
  FaqContentSectionType,
} from './sections/FaqContentSection'
import {
  ContactContentSection,
  ContactContentSectionType,
} from './sections/ContactContentSection'
import { AppearSection } from './blocks/AppearInViewport'

export type {
  DataSectionItem,
  DataSectionItemStyling,
  DataSectionType,
  DocumentSectionItem,
  DocumentSectionType,
  LocationSectionType,
  StepSectionItem,
  StepSectionType,
  TextSectionType,
}
export type ColumnsContentSectionType = ColumnsContentSectionProps & {
  type: 'column'
}
export type ColumnsSectionType = ColumnsContentSectionType

export type ContentSectionType =
  | TextSectionType
  | DataSectionType
  | StepSectionType
  | DocumentSectionType
  | LocationSectionType
  | ColumnsContentSectionType
  | StoriesContentSectionType
  | CtaContentSectionType
  | NewsContentSectionType
  | ThreadContentSectionType
  | InitiativesContentSectionType
  | FaqContentSectionType
  | ContactContentSectionType

export type ContentSectionsProps = {
  sections: ContentSectionType[]
}

export const ContentSections = ({ sections }: ContentSectionsProps) => {
  return sections.map((section, index) => (
    <ContentSection key={index} section={section} />
  ))
}

export type ContentSectionProps = {
  section: ContentSectionType
}

export const ContentSection = ({ section }: ContentSectionProps) => {
  return (
    <AppearSection>
      {match(section)
        .with({ type: 'text' }, (s) => <TextContentSection {...s} />)
        .with({ type: 'data' }, (s) => <DataContentSection {...s} />)
        .with({ type: 'steps' }, (s) => <StepsContentSection {...s} />)
        .with({ type: 'documents' }, (s) => <DocumentsContentSection {...s} />)
        .with({ type: 'column' }, (s) => <ColumnsContentSection {...s} />)
        .with({ type: 'location' }, (s: LocationSectionType) => (
          <LocationContentSection {...s} />
        ))
        .with({ type: 'ctaGrid' }, (s) => <CtaContentSection {...s} />)
        .with({ type: 'stories' }, (s) => <StoriesContentSection {...s} />)
        .with({ type: 'news' }, (s) => <NewsContentSection {...s} />)
        .with({ type: 'thread' }, (s) => <ThreadContentSection {...s} />)
        .with({ type: 'initiatives' }, (s) => (
          <InitiativesContentSection {...s} />
        ))
        .with({ type: 'faqs' }, (s) => <FaqContentSection {...s} />)
        .with({ type: 'contactPanel' }, (s) => (
          <ContactContentSection {...s} />
        ))
        .exhaustive()}
    </AppearSection>
  )
}
